import { onlyNumbers } from './onlyNumbers';
const cpf = function(value) {
  var data = onlyNumbers(value);
  if (!data) return '';
  var result = data.substr(0, 3) + '.' + data.substr(3, 3) + '.' + data.substr(6, 3) + '-' + data.substr(9, 2);
  return result;
};
export { cpf };
